
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M5.636 0C3.074 0 .886 1.659 0 4c.886 2.341 3.074 4 5.636 4 2.562 0 4.75-1.659 5.636-4-.887-2.341-3.074-4-5.636-4zm.001 1.334c1.541 0 2.916 1.032 3.587 2.666-.671 1.634-2.046 2.667-3.587 2.667-1.54 0-2.915-1.033-3.586-2.667.67-1.634 2.045-2.666 3.586-2.666zM3.84 4c0-.952.805-1.728 1.793-1.728.988 0 1.793.776 1.793 1.728 0 .953-.805 1.729-1.793 1.729-.988 0-1.793-.776-1.793-1.729z","fill":"#fff"}})])
          )
        }
      }
    